// 🔧 map_builder.js
// ✅ Purpose: Map/Venue Builder for the LGV Demo Engine
// ✅ Features:
// - Updates the event with venue information
// - Adds realistic map data
// - Future-ready for interactive maps
// - Keeps venue generation separate from Event Builder
// - Fully block-commented for clarity and future devs

import {
  doc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../../firebase";
import { logger } from "../../utils/logger";

import { buildMapSettings } from "../templates/map_defaults";

export const buildVenue = async ({
  eventResult,
  industryTemplate,
} = {}) => {
  if (!eventResult?.eventId) {
    throw new Error(
      "Map Builder requires an event."
    );
  }

    const mapSettings =
    buildMapSettings({
        industryTemplate,
        eventResult,
    });

  // Event map consumers and the admin map editor use settings/voting. The
  // previous root-event write left that canonical document empty, so the
  // public page could not display the seeded map or its markers.
  await setDoc(
    doc(
      db,
      "events",
      eventResult.eventId,
      "settings",
      "voting"
    ),
    {
      ...mapSettings,

      lastSaved:
        serverTimestamp(),

      seededBy: "demo_engine",

      seededMap: true,
    },
    { merge: true }
  );

  logger.log(
    "🗺️ Map Builder completed.",
    {
      value: {
        eventId:
          eventResult.eventId,
      },
    }
  );

  return {
    builder: "map_builder",

    ready: true,

    createdCount: 1,

    mapSettings,

    message:
      "Venue information created.",
  };
};

export const buildVenueShell =
async ({
  eventResult,
  industryTemplate,
} = {}) => {
  if (!eventResult?.eventId) {
    return {
      builder: "map_builder",

      ready: false,

      createdCount: 0,

      message:
        "Map Builder requires an event.",
    };
  }

  return buildVenue({
    eventResult,
    industryTemplate,
  });
};
